enum NavigationMenuKey {
  RESIDENCES = 'residences',
  INTERACTIVE_MAP = 'interactive-map',
  VIDEOS = 'videos',
  GALLERY = 'gallery',
  BROCHURE = 'brochure',
  TEAM = 'team',
  EXTERNAL_ROUTES = 'external-routes',
  SHORTLIST = 'shortlist',
  SESSION_SETTINGS = 'session-settings',
  TOOLS = 'tools',
  ADTHREED = '3d',
}

enum RouteKey {
  VISION = 'vision',
  AREA_VIEW = 'area-view',
  LEVEL_VIEW = 'level-view',
  BUILDING = 'building',
  AREA_VIEW_HOUSE_AND_LAND = 'area-view-house-and-land',
  PRECINCT = 'precinct',
  STAGES = 'stages',
  LOT_VIEW = 'lot-view',
  INTERACTIVE_MAP = 'interactive-map',
  VIDEO_GALLERY = 'video-gallery',
  GALLERY = 'gallery',
  TEAMS = 'teams',
  BROCHURE = 'brochure',
  EXTERNAL_VIEWS = 'external-views',
  SHORTLIST = 'shortlist',
  PANORAMIC = 'panoramic',
  PANORAMIC_VIEW = 'panoramic-view',
  SNAPLOADER_VIEW = 'snaploader-view',
  THREE_D_BUILDING = '3d-building',
  LOCATION = 'location',
  DASHBOARD = 'dashboard',
  ADTHREED = '3d',
}

enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}

enum Template {
  Default = 'default',
  V2 = 'v2',
}

enum AssetHandlerType {
  LEGACY = 'legacy',
  NEW = 'new',
}

export const DEFAULT_SHOWCASE_ROOM = 'default'
export const PER_PAGE = 5

export const API_VERSION_1 = 'v1'
export const API_VERSION_2 = 'v2'
export const API_VERSION_3 = 'v3'

export { NavigationMenuKey, RouteKey, SortOrder, Template, AssetHandlerType }
